import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "YammerPublisher" */ './lazyIndex'),
    { name: 'YammerPublisher' }
);

// Delay loaded imports
export const lazyOpenYammerPublisher: LazyAction<
    typeof lazyIndex.openYammerPublisher,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openYammerPublisher);
export const OpxYammerPublisher: typeof lazyIndex.OpxYammerPublisher = createLazyComponent(
    lazyModule,
    m => m.OpxYammerPublisher
);
